import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';

@Component({
  selector: 'miq-address-header-renderer',
  template: `
    <span>
      {{ value }}
    </span>
  `,
  styles: [],
  standalone: false,
})
export class AddressHeaderRendererComponent implements ICellRendererAngularComp {
  public params!: ICellRendererParams;
  public value!: string;

  refresh(params: ICellRendererParams): boolean {
    this.setValues(params);
    return true;
  }

  agInit(params: ICellRendererParams): void {
    this.setValues(params);
  }

  private setValues(params: ICellRendererParams) {
    this.params = params;
    this.value = this.params.value;
    const data = this.params.node?.data;
    if (data != null) {
      this.value = `${data.streetNumber1 ?? ''} ${data.streetNumber2 ?? ''} ${data.streetName ?? ''} ${
        data.streetType ?? ''
      }`;
    }
  }
}
